import React from 'react';

type TextProps = {
  text: string;
};

export const Text = ({ text }: TextProps) => {
  text = text.replace(/\s+/g, ' ');
  text = text.replace(/<[^>]*>/g, '');
  text = text.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');

  return <p dangerouslySetInnerHTML={{ __html: text }} />;
};
